module.exports = __webpack_public_path__ + "img/other_clock.bf1bd7f0.png";